import useModelProviders from "ai-management/hooks/useModelProviders";
const useProviderNames = () => {
  const { data: providers } = useModelProviders();
  return (providerId) => {
    var _a, _b;
    return (_b = (_a = providers.find(({ id }) => id === providerId)) == null ? void 0 : _a.display) != null ? _b : providerId;
  };
};
export default useProviderNames;
